import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { VERSION } from '../version';

function TerminosCondiciones() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
    <div className="legal-content" style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
      <h1>Términos y Condiciones</h1>
      <p style={{ color: '#666', marginBottom: '30px' }}>Última actualización: 7 de febrero de 2026</p>

      <section style={{ marginBottom: '30px' }}>
        <h2>1. Objeto</h2>
        <p>
          Los presentes Términos y Condiciones regulan el acceso y uso de la plataforma CoachFlow CRM, 
          un servicio de gestión profesional ofrecido por Caja de Lapices, S.L.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>2. Acceso al servicio</h2>
        <p>
          El acceso a la plataforma requiere el registro previo del usuario mediante credenciales proporcionadas 
          por el administrador. El usuario es responsable de mantener la confidencialidad de sus credenciales.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>3. Uso aceptable</h2>
        <p>El usuario se compromete a:</p>
        <ul>
          <li>Utilizar la plataforma únicamente para fines profesionales legítimos.</li>
          <li>No introducir datos falsos o engañosos.</li>
          <li>No intentar acceder a datos de otros usuarios sin autorización.</li>
          <li>No realizar acciones que puedan dañar o sobrecargar la plataforma.</li>
          <li>Cumplir con la legislación aplicable en materia de protección de datos.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>4. Propiedad intelectual</h2>
        <p>
          Todos los derechos de propiedad intelectual sobre la plataforma, su diseño, código fuente, 
          logotipos y contenido son propiedad de Caja de Lapices, S.L. Se prohíbe la reproducción, distribución o 
          modificación sin autorización expresa.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>5. Protección de datos</h2>
        <p>
          El tratamiento de datos personales se rige por nuestra{' '}
          <Link to="/privacidad" style={{ color: '#007bff' }}>Política de Privacidad</Link>, 
          conforme al Reglamento General de Protección de Datos (RGPD) y la legislación española aplicable.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>6. Disponibilidad del servicio</h2>
        <p>
          Caja de Lapices, S.L. se esfuerza por mantener la plataforma disponible de forma continua, pero no garantiza 
          un servicio ininterrumpido. Se podrán realizar tareas de mantenimiento que pueden causar 
          interrupciones temporales del servicio.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>7. Limitación de responsabilidad</h2>
        <p>
          Caja de Lapices, S.L. no será responsable de daños indirectos, incidentales o consecuentes derivados del uso 
          o la imposibilidad de uso de la plataforma. La responsabilidad total se limitará al importe 
          abonado por el usuario en los últimos 12 meses.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>8. Modificaciones</h2>
        <p>
          Caja de Lapices, S.L. se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. 
          Las modificaciones serán comunicadas a los usuarios y entrarán en vigor desde su publicación.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>9. Legislación aplicable</h2>
        <p>
          Estos Términos y Condiciones se rigen por la legislación española. Cualquier disputa será 
          sometida a los tribunales competentes de España.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>10. Contacto</h2>
        <p>
          Para cualquier consulta sobre estos Términos y Condiciones, puede contactarnos a través 
          de los canales habilitados en la plataforma.
        </p>
      </section>

      <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #eee', textAlign: 'center' }}>
        <Link to="/" style={{ color: '#007bff', textDecoration: 'none' }}>← Volver al inicio</Link>
        <span style={{ margin: '0 15px', color: '#ccc' }}>|</span>
        <Link to="/privacidad" style={{ color: '#007bff', textDecoration: 'none' }}>Política de Privacidad</Link>
      </div>

    </div>
    <footer className="app-footer">
      <p>
        &copy; 2025-26 Caja de Lapices, S.L. All rights reserved. | Made with Love in Spain | v{VERSION}
        <span className="footer-links">
          {' | '}<Link to="/privacidad" style={{ color: 'inherit', opacity: 0.8 }}>Política de Privacidad</Link>
          {' | '}<Link to="/terminos" style={{ color: 'inherit', opacity: 0.8 }}>Términos y Condiciones</Link>
        </span>
      </p>
    </footer>
    </>
  );
}

export default TerminosCondiciones;
